import { User } from "@/lib/types/user-types"
import { DEVELOPER_IDS } from "@/lib/user/roles-and-permissions"
import { defaultSettings } from "./default-user"


export function isUserSubscribed(user: User) {
    return user.subscription === 'pro' || user.subscription === 'advanced' || user.subscription === 'basic'
}

export function isUserFree(user: User) {
    return user.subscription === 'free'
}

export function isUserGuest(user: User) {
    return user ? true : false
}

export function isUserAdmin(user: User | string) {
    if (typeof user === 'string') {
        return user.endsWith('@tryblend.ai') || user.endsWith('@marclamy.com')
    }
    return user.email.endsWith('@tryblend.ai') ||
        DEVELOPER_IDS.includes(user.id)
}

export function doesUserHavePositiveBalance(user: User) {
    return user.balance > 0
}



export function addSettingsToUserObject(user: User): User {
    return {
        ...user,
        settings: {
            ...defaultSettings,
            ...(user.settings || {})
        }
    }
}